import React, { FunctionComponent } from "react";
import { Typography, Box } from "@material-ui/core";

export const ListItem: FunctionComponent = (props) =>(
  <Box my={1} component="li">
    <Typography component="span">
      {props.children}
    </Typography>
  </Box>
)